<h4 mat-dialog-title style="padding: 10px;text-align: center;">Add Veterinarian</h4>

<mat-dialog-content>
    <div style="padding: 10px;">
        <label for="vetName" class="font-weight-bold">Veterinarian Name <span style="color: red;"> * </span> </label>
        <div id="vetName">
            <mat-form-field appearance="outline" style="width:100%">
                <input matInput placeholder="Veterinarian Name" [(ngModel)]="data.name" required>
            </mat-form-field>
        </div>
        <label for="vetPhone" class="font-weight-bold">Veterinarian Phone <span style="color: red;"> * </span> </label>
        <div id="vetPhone">
            <mat-form-field appearance="outline" style="width:100%">
                <input matInput placeholder="Ex. 555-555-1234" mask="(000) 000-0000" [(ngModel)]="data.phone"
                    [showMaskTyped]="true">
            </mat-form-field>
        </div>
        <label for="vetAddress" class="font-weight-bold">Veterinarian Address  </label>
        <div id="vetAddress">
            <mat-form-field appearance="outline" style="width:100%">
                <input #searchGoogleAddressInput matInput placeholder="search for location"
                required [(ngModel)]="data.displayAddress" (change)="googlePlacesSearch()" />
            </mat-form-field>
        </div>
        <label for="vetFax" class="font-weight-bold">Veterinarian Fax </label>
        <div id="vetFax">
            <mat-form-field appearance="outline" style="width:100%">
                <input matInput placeholder="Ex. 555-555-1234" mask="(000) 000-0000" [(ngModel)]="data.fax"
                    [showMaskTyped]="true">
            </mat-form-field>
        </div>
        <p *ngIf="errorMessage && errorMessage != ''" style="color:red;">{{errorMessage}}</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions style="padding:10px;float:right; margin-bottom: 0px;">
    <button mat-button mat-dialog-close mat-button style="background-color:#ff0000;color: white;">Cancel</button>
    <button mat-button style="background-color:#41A049;color: white;"
        (click)="addVet()">Save</button>
</mat-dialog-actions>